import React, { useEffect, useRef } from 'react';

const img = new Image();
img.src = 'terrain.png';

const tileImg = new Image();
tileImg.src = 'tiles.png';

const mapSize = function(tiles) {
  const rows = tiles.split('\n');
  const w = rows[0].length;
  const h = rows.length;
  return [w, h];
}

export const drawTile = function(ctx, t, x, y) {
  const sx = t % 16;
  const sy = Math.floor(t/16);
  const ix = (1 + sx*34);
  const iy = (1 + sy*34);

  ctx.drawImage(img, ix, iy, 32, 32, x*32, y*32, 32, 32);
}

export const drawIcon = function(ctx, i, x, y) {
  const sx = i % 40;
  const sy = Math.floor(i / 40);
  const ix = (1 + sx*34);
  const iy = (1 + sy*34);

  ctx.drawImage(tileImg, ix, iy, 32, 32, x*32, y*32, 32, 32);
}

const drawMap = function(canvas, props) {
  const map = props.map;
  const ctx = canvas.getContext("2d");
  const [ w, h ] = mapSize(map.Tiles);

  const indexToPos = function(i) {
    const y = Math.floor(i / (w + 1));
    const x = i % (w + 1);

    return [ x, y ];
  };

  ctx.fillStyle = 'black';
  ctx.fillRect(0, 0, w*32, h*32);

  var i;
  for (i = 0; i < map.Tiles.length; i++) {
    const [ tx, ty ] = indexToPos(i);

    const t = map.Tiles.charCodeAt(i)-32;
    drawTile(ctx, t, tx, ty);
  }

  if (props.onDrawTile) {
    for (i = 0; i < map.Tiles.length; i++) {
      const [ tx, ty ] = indexToPos(i);
      props.onDrawTile(ctx, tx, ty);
    }
  }
}

const tilePosFromEvent = function(evt) {
  const x = evt.nativeEvent.offsetX;
  const y = evt.nativeEvent.offsetY;

  const tx = Math.floor(x / 32);
  const ty = Math.floor(y / 32);
  return [ tx, ty ];
}

const MapView = function(props) {
  const map = props.map;
  const [ w, h ] = mapSize(map.Tiles);
  const canvasEl = useRef(null);

  const click = function(evt) {
      const [ tx, ty ] = tilePosFromEvent(evt);

      if (props.onClick) props.onClick(tx, ty);
  };

  const up = function(evt) {
      const [ tx, ty ] = tilePosFromEvent(evt);

      if (props.onUp) props.onUp(tx, ty);
  };

  const down = function(evt) {
      const [ tx, ty ] = tilePosFromEvent(evt);

      if (props.onDown) props.onDown(tx, ty);
  };

  const move = function(evt) {
    const [ tx, ty ] = tilePosFromEvent(evt);

    if (props.onMove) props.onMove(tx, ty);
  }

  const out = function(evt) {
    if (props.onMove) props.onMove(null, null);
  }

  useEffect(() => {
    drawMap(canvasEl.current, props);
  }, [props]);

  return (
    <canvas ref={canvasEl} width={w*32} height={h*32}
            onMouseDown={down} onMouseUp={up}
            onClick={click} onMouseMove={move} onMouseLeave={out}/>
  )
}


export default MapView;
